import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import en from './en/translation.json';
import fr from './fr/translation.json';
import es from './es/translation.json';
import de from './de/translation.json';
import ru from './ru/translation.json';
import pt from './pt/translation.json';
import ar from './ar/translation.json';
import zh from './zh/translation.json';
import ko from './ko/translation.json';
import ja from './ja/translation.json';
import th from './th/translation.json';
import vi from './vi/translation.json';
import tr from './tr/translation.json';
import hi from './hi/translation.json';
import id from './id/translation.json';
import it from './it/translation.json';
import pl from './pl/translation.json';
import nl from './nl/translation.json';
import { convertLanguageJsonToObject } from './translations';

// i18n-multilang-engine Phase 6 — Phase 1: en/fr/es/de/ru/pt ; Phase 4: ar/zh/ko ; Phase 5: ja/th/vi ; Phase 6: tr/hi/id/it/pl/nl.
// Généré par generate-ui-translations.js --langs <lang> via LiteLLM (module translate/*).
export const SUPPORTED_LANGUAGES = ['en', 'fr', 'es', 'de', 'ru', 'pt', 'ar', 'zh', 'ko', 'ja', 'th', 'vi', 'tr', 'hi', 'id', 'it', 'pl', 'nl'] as const;

export const translationsJson = {
  en: {
    translation: en,
  },
  fr: {
    translation: fr,
  },
  es: {
    translation: es,
  },
  de: {
    translation: de,
  },
  ru: {
    translation: ru,
  },
  pt: {
    translation: pt,
  },
  ar: {
    translation: ar,
  },
  zh: {
    translation: zh,
  },
  ko: {
    translation: ko,
  },
  ja: {
    translation: ja,
  },
  th: {
    translation: th,
  },
  vi: {
    translation: vi,
  },
  tr: {
    translation: tr,
  },
  hi: {
    translation: hi,
  },
  id: {
    translation: id,
  },
  it: {
    translation: it,
  },
  pl: {
    translation: pl,
  },
  nl: {
    translation: nl,
  },
};

// Create the 'translations' object to provide full intellisense support for the static json files.
convertLanguageJsonToObject(en);

export const i18n = i18next
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  .use(LanguageDetector)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    resources: translationsJson,
    supportedLngs: SUPPORTED_LANGUAGES as unknown as string[],
    fallbackLng: 'en',
    // load: 'languageOnly' → 'fr-FR' devient 'fr' (matche SUPPORTED_LANGUAGES
    // qui contient les codes 2 lettres). Évite que navigator.language='fr-FR'
    // tombe en fallback 'en' par non-correspondance.
    load: 'languageOnly',
    // lng intentionally omitted — LanguageDetector choisit la langue.
    // Détection : 1) ?lng= URL · 2) localStorage (key i18nextLng = choix
    // manuel utilisateur, persiste entre sessions) · 3) navigator.language
    // (1ʳᵉ visite sans choix manuel = langue du navigateur, auto-redirect
    // vers fr/es/de/... si supporté) · 4) htmlTag.
    detection: {
      order: ['querystring', 'localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
      lookupQuerystring: 'lng',
      lookupLocalStorage: 'i18nextLng',
    },
    debug:
      process.env.NODE_ENV !== 'production' && process.env.NODE_ENV !== 'test',

    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
  });
